module.exports = __webpack_public_path__ + "img/4.3c3a3325.png";